import { mapState } from 'vuex';
import GlobalConfig from '@/config/global';

export default {
    computed: {
        ...mapState({
            accumulatedScore: (state) => state.accumulatedScore,
            loginDayCount: (state) => state.loginDayCount,
        }),
        level() {
            return Math.floor(this.score / 100) + 1;
        },
        medal() {
            const N = 100;
            const BASE = 10;
            if (this.level >= 6 * N) return 5; // 500
            if (this.level >= 3 * N) return 4; // 300
            if (this.level >= 1 * N) return 3; // 100
            if (this.level >= BASE + 0 * N) return 2; // 10
            return 1;
        },
        score() {
            const LOGIN_DAY_COUNT = this.loginDayCount || 0;
            const SIGN_IN_BONUS = LOGIN_DAY_COUNT * GlobalConfig.scorePerSign;

            if (!this.accumulatedScore?.game1) return 0;
            return this.accumulatedScore[this.$route.params.type][
                `level${this.$route.params.level}`
            ] + SIGN_IN_BONUS;
        },
    },
};
